import { createSlice } from "@reduxjs/toolkit";
import { generateDataSet } from "../actions/stripePayment.actions";

const initialState = {
  isLoading: false,
  data: null,
};

const generatePurchaseDatasetSlice = createSlice({
  name: "Generate Purchase Dataset",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(generateDataSet.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(generateDataSet.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(generateDataSet.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default generatePurchaseDatasetSlice.reducer;
